export enum propertiesActionTypes {
  PROPERTIES_REQUESTED = 'PROPERTIES_REQUESTED',
  PROPERTIES_SUCCEEDED = 'PROPERTIES_SUCCEEDED',
  PROPERTIES_FAILED = 'PROPERTIES_FAILED'
}
